<ng-container *ngIf="gradeWise">
    <div class="overview overview-gradewise">
        <div class="overview-data">
            <div class="tpheading">
                <div class="d-flex align-items-center justify-content-between">
                    <h2>{{card_title | translate}} 
                        <!-- <span class="info-tooltip" matTooltipPosition="above"
                    matTooltipClass="custom-tooltip" [matTooltip]="infoTooltipContent"><img
                        src="assets/images/contact_support.svg" alt=""></span> -->
                    </h2> 
                    <app-dropdown-radio-selection [dropDownOption]="developerDropdown"
                    (dropDownValue)="dropDownChange($event)" [showInvalueText]="false"></app-dropdown-radio-selection>

                </div>
                <div class="untill" *ngIf="untillDate">
                    <span>{{"reports.asOf" | translate}}</span>
                    <span class="directionLtr"> {{ untillDate ? untillDate : ''}}</span>
                    <!-- <span *ngIf="propertiesCount">, {{propertiesCount | number: '1.0-0'}} {{'reports.projectsProperties' | translate}}</span> -->
                </div>
            </div>
            <ng-container *ngTemplateOutlet="selected_category?.length ? gradeData : noRecordsTemplate"></ng-container>
            <ng-template #gradeData>
                <div class="grade-outer">
                    <div class="gradelist d-flex justify-content-between" *ngFor="let item of selected_category">
                        <div class="gsec">
                            <strong>{{item.grade == '-' ? '-' : (item.grade | translate)}}</strong>
                            <span>{{item.grade == '-' ? ('reports.undefined' | translate) : ('reports.grade' | translate)}}</span>
                        </div>
                        <div class="gvalue">
                            <h1 class="directionLtr">
                                <ng-container>
                                    {{item.rate ? (item.rate | number: '1.0-1') : '-'}}
                                    <sup *ngIf="item.rate">{{symble}}</sup>
                                </ng-container>
                            </h1>
                            <!-- <span class="d-flex justify-content-end">{{item?.property_count ? (item.property_count | number: '1.0-1') : '-'}} {{'reports.projectsProperties' |
                                translate}}</span> -->
                        </div>
                    </div>
                </div>
            </ng-template>
        </div>
    </div>
</ng-container>

<ng-template #noRecordsTemplate>
    <div class="data_unavail">
        <span>
            {{"reports.data_not_available" | translate}} <mat-icon role="img"
                class="mat-icon notranslate material-icons mat-ligature-font mat-icon-no-color" aria-hidden="true"
                data-mat-icon-type="font">equalizer</mat-icon>
        </span>
    </div>

</ng-template>